import { FieldDefinition } from '../../fields/field-definition';
import { InputTypes } from '../../generic-form/enums/input-type';
import { normalizeEmptyNumericFields } from '../../utils/normalize-utils';

export function normalizeItemForSave(item: any, fields: FieldDefinition[]): any {
  const numericKeys = fields
    .filter(field => field.fieldOptions?.type === InputTypes.Number)
    .map(field => field.key);

  return normalizeEmptyNumericFields(item, numericKeys);
}
